import { ABIERTA_STATE, APROBADA_STATE, CERRADA_STATE, ENVIADA_APROBACION_STATE, PENDIENTE_STATE, CANCELADA_STATE, CERRADA_CON_RETRASO_STATE, PLANIFICADA_ID, RECHAZADA_STATE, REFORZAMIENTO_ID, ROL_ADMINISTRADOR, ROL_CONTRATISTA, ROL_EMPRESA, PENDIENTE_CON_RETRASO_STATE } from '../utils/constants';
import { LoginService } from './login.service';
import * as i0 from "@angular/core";
import * as i1 from "./login.service";
export class ValidationService {
    constructor(loginService) {
        this.loginService = loginService;
    }
    isActiveIconSend(capacitacion, roleId) {
        console.log('isActiveIconSend');
        let rolid = roleId;
        if ((rolid == ROL_CONTRATISTA && capacitacion.roleId == ROL_CONTRATISTA &&
            capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
            (capacitacion.stateId === ABIERTA_STATE || capacitacion.stateId === RECHAZADA_STATE)) ||
            (rolid == ROL_ADMINISTRADOR && capacitacion.roleId == ROL_CONTRATISTA &&
                capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
                (capacitacion.stateId === ABIERTA_STATE || capacitacion.stateId === RECHAZADA_STATE)) ||
            (rolid == ROL_ADMINISTRADOR && capacitacion.roleId == ROL_CONTRATISTA &&
                (capacitacion.stateId === ABIERTA_STATE || capacitacion.stateId === RECHAZADA_STATE)) ||
            ((rolid === ROL_CONTRATISTA) &&
                capacitacion.roleId == ROL_CONTRATISTA &&
                capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
                (capacitacion.stateId === RECHAZADA_STATE && capacitacion.motivoId != 4))) {
            return true;
        }
    }
    isActiveIconDelete(capacitacion, roleId) {
        console.log('isActiveIconDelete');
        let rolid = roleId;
        if ((capacitacion.roleId == ROL_CONTRATISTA &&
            rolid == ROL_CONTRATISTA &&
            (capacitacion.stateId === ABIERTA_STATE || capacitacion.stateId === ENVIADA_APROBACION_STATE))
            ||
                (capacitacion.roleId == ROL_CONTRATISTA && rolid == ROL_ADMINISTRADOR)
            ||
                (rolid == ROL_ADMINISTRADOR)) {
            return true;
        }
    }
    isActiveIconEdit(capacitacion) {
        return true;
        // if(rolid != ROL_CONTRATISTA){
        // }else{
        // }
        // if (
        //   (
        //     capacitacion.roleId == ROL_CONTRATISTA &&
        //     (rolid === ROL_CONTRATISTA) &&
        //     (capacitacion.stateId === PENDIENTE_CON_RETRASO_STATE)
        //   ) ||
        //   (
        //     capacitacion.roleId == ROL_CONTRATISTA &&
        //     (rolid === ROL_CONTRATISTA) &&
        //     (capacitacion.stateId === ENVIADA_APROBACION_STATE || capacitacion.stateId === ABIERTA_STATE)
        //   ) ||
        //   (capacitacion.roleId == ROL_CONTRATISTA &&
        //     rolid == ROL_ADMINISTRADOR
        //   ) ||
        //   (capacitacion.roleId == ROL_CONTRATISTA &&
        //     rolid == ROL_EMPRESA &&
        //     capacitacion.stateId === ENVIADA_APROBACION_STATE || capacitacion.stateId === RECHAZADA_STATE
        //   ) ||
        //   (
        //     capacitacion.roleId == ROL_CONTRATISTA &&
        //     (rolid == ROL_CONTRATISTA || rolid == ROL_EMPRESA) &&
        //     (capacitacion.stateId === CERRADA_STATE ||
        //       capacitacion.stateId === CERRADA_CON_RETRASO_STATE ||
        //       capacitacion.stateId === CANCELADA_STATE) &&
        //     (this.isTreintaDias(capacitacion))
        //   ) ||
        //   (
        //     capacitacion.roleId == ROL_EMPRESA && rolid == ROL_EMPRESA && capacitacion.stateId === ABIERTA_STATE
        //   ) ||
        //   (
        //     capacitacion.roleId == ROL_EMPRESA &&
        //     rolid == ROL_EMPRESA &&
        //     (capacitacion.stateId === ABIERTA_STATE || (capacitacion.stateId === CERRADA_STATE && this.isTreintaDias(capacitacion)))
        //   ) ||
        //   (
        //     capacitacion.roleId == ROL_CONTRATISTA &&
        //     (rolid === ROL_CONTRATISTA) &&
        //     (capacitacion.stateId === RECHAZADA_STATE && capacitacion.motivoId != 4)
        //   ) ||
        //   (
        //     capacitacion.roleId == ROL_CONTRATISTA &&
        //     (rolid === ROL_CONTRATISTA || rolid === ROL_EMPRESA) &&
        //     (capacitacion.stateId === APROBADA_STATE || capacitacion.stateId === PENDIENTE_STATE)
        //   ) ||
        //   (
        //     (capacitacion.roleId == ROL_ADMINISTRADOR || capacitacion.roleId == ROL_EMPRESA) &&
        //     (rolid === ROL_ADMINISTRADOR) &&
        //     (capacitacion.stateId === ABIERTA_STATE || capacitacion.stateId === CERRADA_STATE)
        //   )
        // ) {
        //   return true;
        // }
    }
    isTreintaDias(capacitacion) {
        if (!capacitacion.cierreDate)
            return false;
        else {
            let d = new Date();
            d.setDate(d.getDate() - 30);
            let datePart = capacitacion.cierreDate.split(" ")[0].split("/");
            let dateUpdate = new Date(+datePart[2], datePart[1] - 1, +datePart[0]);
            return dateUpdate >= d;
        }
    }
    isActiveEditOnApprove(capacitacion, roleId) {
        console.log('isActiveEditOnApprove');
        let rolid = roleId;
        if (capacitacion.roleId == ROL_CONTRATISTA &&
            (rolid === ROL_CONTRATISTA || rolid === ROL_EMPRESA) &&
            (capacitacion.stateId === APROBADA_STATE || capacitacion.stateId === PENDIENTE_STATE
                || capacitacion.stateId === PENDIENTE_CON_RETRASO_STATE) || ((capacitacion.stateId === CERRADA_STATE ||
            capacitacion.stateId === CERRADA_CON_RETRASO_STATE ||
            capacitacion.stateId === CANCELADA_STATE) &&
            (this.isTreintaDias(capacitacion)))) {
            return true;
        }
    }
    isActiveIconAccept(capacitacion, rolId) {
        console.log('isActiveIconAccept');
        let rolid = rolId;
        if (((rolid == ROL_EMPRESA || rolid == ROL_ADMINISTRADOR) &&
            capacitacion.roleId == ROL_CONTRATISTA &&
            capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
            capacitacion.stateId === ENVIADA_APROBACION_STATE)) {
            return true;
        }
    }
    isActiveIconClose(capacitacion, roleId) {
        console.log('isActiveIconClose');
        let rolid = roleId;
        if ((capacitacion.roleId == ROL_CONTRATISTA &&
            (rolid === ROL_CONTRATISTA) &&
            (capacitacion.stateId === PENDIENTE_CON_RETRASO_STATE)) ||
            ((rolid == ROL_CONTRATISTA || rolid == ROL_EMPRESA || rolid == ROL_ADMINISTRADOR) &&
                capacitacion.roleId == ROL_CONTRATISTA &&
                capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
                (capacitacion.stateId === APROBADA_STATE || capacitacion.stateId === PENDIENTE_STATE)) ||
            ((rolid == ROL_EMPRESA || rolid == ROL_ADMINISTRADOR) &&
                capacitacion.roleId == ROL_EMPRESA &&
                capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
                (capacitacion.stateId === ABIERTA_STATE)) ||
            ((rolid == ROL_ADMINISTRADOR) &&
                capacitacion.roleId == ROL_ADMINISTRADOR &&
                capacitacion.capacitacionTypeId === PLANIFICADA_ID &&
                (capacitacion.stateId === ABIERTA_STATE)) || (capacitacion.capacitacionTypeId === REFORZAMIENTO_ID &&
            (capacitacion.stateId === ABIERTA_STATE))) {
            return true;
        }
    }
    isActiveIconReject(capacitacion, roleId) {
        console.log('isActiveIconReject');
        let rolid = roleId;
        if (capacitacion.roleId == ROL_CONTRATISTA &&
            capacitacion.stateId === ENVIADA_APROBACION_STATE &&
            (rolid == ROL_EMPRESA || rolid == ROL_ADMINISTRADOR)) {
            return true;
        }
    }
    canDelete(capacitacion, role) {
        return this.isActiveIconDelete(capacitacion, role);
    }
    canEditOnReject(capacitacion) {
        if (capacitacion.roleId == ROL_CONTRATISTA &&
            capacitacion.stateId === RECHAZADA_STATE //FALTA MOTIVO CANCELADO
        ) {
            return true;
        }
    }
    canEdit(capacitacion) {
        return this.isActiveIconEdit(capacitacion);
    }
    canSendForAcceptance(capacitacion, roleId) {
        return this.isActiveIconSend(capacitacion, roleId);
    }
    canAcceptOrReject(capacitacion, roleId) {
        return this.isActiveIconAccept(capacitacion, roleId);
    }
    canClose(capacitacion, roleId) {
        return this.isActiveIconClose(capacitacion, roleId);
    }
    canAssignWorkers(capacitacion) {
        if (capacitacion.capacitacionTypeId === PLANIFICADA_ID) {
            return (capacitacion.roleId == ROL_CONTRATISTA && (capacitacion.stateId === APROBADA_STATE
                || capacitacion.stateId === CERRADA_STATE
                || capacitacion.stateId === PENDIENTE_STATE
                || capacitacion.stateId === PENDIENTE_CON_RETRASO_STATE))
                || (capacitacion.roleId == ROL_ADMINISTRADOR);
        }
        return true;
    }
}
ValidationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ValidationService_Factory() { return new ValidationService(i0.ɵɵinject(i1.LoginService)); }, token: ValidationService, providedIn: "root" });
